export default "__VITE_ASSET__957f8a0f__"